/**
 * Font weight mappings for the Braun theme.
 *
 * For consistency and to minimize code changes, we use:
 *   - normal: 400
 *   - medium: 500
 *   - semibold: 700
 *   - bold: 900
 *
 * Both 'light' and 'normal' are mapped to 400 to align with usage across the codebase.
 */
export default {
    hairline: 100,
    extrabold: 800,
    black: 900,
    thin: 200,
    light: 400,
    normal: 400,
    medium: 500,
    semibold: 700,
    bold: 900,
}
